import React from "react";
import { useModal } from "../../context/ModalContext";
import fullLogo from "../../assets/images/svg/unicornio-brown.svg";
import "../../assets/styles/ModalConfirmation.css";

const ModalConfirmation = ({ data }) => {
  const { closeModal } = useModal();
  const {
    title = "Confirmação",
    message = "Tem certeza que deseja realizar esta ação?",
    cancelLabel = "Voltar",
    confirmLabel = "Confirmar",
    onConfirm,
    onCancel,
  } = data || {};

  const handleCancel = () => {
    try {
      onCancel?.();
    } finally {
      closeModal();
    }
  };

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    closeModal();
  };

  return (
    <div
      className="ModalConfirmation text-center p-4 p-md-5"
      style={{
        backgroundColor: "#E6DDCE",
        borderRadius: "24px",
        position: "relative",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.12)",
      }}
    >
      <button
        type="button"
        className="btn-close position-absolute"
        style={{ top: "20px", right: "20px", zIndex: 10 }}
        data-bs-dismiss="modal"
        aria-label="Close"
        onClick={handleCancel}
      />

      <div className="d-flex justify-content-center mb-3 mb-md-4">
        <img
          src={fullLogo}
          alt="Puríssima"
          style={{ maxHeight: "85px", width: "auto" }}
        />
      </div>

      <h3
        className="mb-3 text-uppercase"
        style={{
          color: "#3D2C06",
          fontWeight: 700,
          fontSize: "1.25rem",
          letterSpacing: "0.5px",
        }}
      >
        {title}
      </h3>

      <p
        className="mb-4 mx-auto"
        style={{
          color: "#5C4B2E",
          fontSize: "0.95rem",
          lineHeight: "1.55",
          maxWidth: "420px",
        }}
      >
        {message}
      </p>

      <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-2 gap-sm-3 mt-4">
        <button
          type="button"
          className="btn btn-outline-secondary px-4 py-2 order-2 order-sm-1"
          onClick={handleCancel}
          style={{
            borderRadius: "30px",
            fontSize: "14px",
            fontWeight: 600,
            borderColor: "#7B6A58",
            color: "#3D2C06",
            background: "transparent",
            minWidth: "130px",
          }}
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          className="btn btn-success px-4 py-2 order-1 order-sm-2"
          onClick={handleConfirm}
          style={{
            borderRadius: "30px",
            fontSize: "14px",
            fontWeight: 600,
            backgroundColor: "#274625",
            borderColor: "#274625",
            color: "#fff",
            minWidth: "150px",
          }}
        >
          {confirmLabel}
        </button>
      </div>
    </div>
  );
};

export default ModalConfirmation;
